export default (payload) => ({
  type: 'DELETE_HARDWARE_STATE',
  payload,
});
